import PropTypes from 'prop-types';
import { useField } from 'react-final-form';
import { injectIntl } from 'react-intl';
import { WrappedLocationAddressField, useLocationAddressFields } from '@unite-us/app-components';
import { GOOGLE_MAPS_API_KEY } from '../env.config';

import formUtils from '../utils/formUtils';

function CustomLocationAddressField({
  id,
  intl,
  label,
  required,
}) {
  const validate = required ? formUtils.required() : null;
  const fields = useLocationAddressFields(useField, { city: { validate } });
  const cityTouched = fields.city.meta.touched;

  const requiredMessage = intl.formatMessage({
    id: 'GJBQfx',
    description: 'required',
    defaultMessage: 'Required',
  });

  return (
    <WrappedLocationAddressField
      id={id}
      label={label}
      apiKey={GOOGLE_MAPS_API_KEY}
      fieldNamePath={null}
      required={required}
      requiredMessage={requiredMessage}
      initialTouched={cityTouched}
      {...fields}
    />
  );
}

CustomLocationAddressField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  required: PropTypes.bool,
  language: PropTypes.string.isRequired,
};

CustomLocationAddressField.defaultProps = {
  required: false,
};

export default injectIntl(CustomLocationAddressField);